import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const preselectedRole = searchParams.get("role"); // "client" | "contractor" | null

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        // Clear the hash and query from the URL for cleanliness
        window.history.replaceState(null, "", window.location.pathname);

        toast.success("Signed in with Google");

        let user = data.user;

        // If the user came from the role picker with ?role=..., apply it now
        if (
          preselectedRole &&
          !user.role &&
          (preselectedRole === "client" || preselectedRole === "contractor")
        ) {
          try {
            await api.post("/users/role", { role: preselectedRole });
            user = { ...user, role: preselectedRole };
          } catch (e) {
            /* fall through */
          }
        }

        // Route based on onboarding state
        if (user.role === "admin") navigate("/admin", { replace: true });
        else if (!user.role) navigate("/role", { replace: true });
        else if (user.role === "contractor" && !user.contractor_profile)
          navigate("/contractor/register", { replace: true });
        else if (user.role === "client") navigate("/client/categories", { replace: true });
        else navigate("/dashboard", { replace: true });

        // Full reload so AuthProvider re-runs /auth/me and picks up the new cookie
        setTimeout(() => window.location.reload(), 50);
      } catch (err) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/auth", { replace: true });
      }
    })();
  }, [location.hash, navigate, searchParams]);

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-white"
      data-testid="auth-callback-screen"
    >
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-[#E5E2DB] border-t-[#C65D47]" />
        <p className="mt-6 font-display text-lg text-[#0A0F0D]">Finishing sign-in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
